export interface Brand {
  uniqueId: string;
  url: string;
  name: string;
  icon?: {
    media?: {
      file?: string;
    };
  };
  showAU?: boolean;
  showNZ?: boolean;
  media?: string;
}

interface UseCrossBrandTrafficProps {
  brands: Brand[];
  siteLocale: string;
}

interface ProcessedBrand {
  uniqueId: string;
  url: string;
  name: string;
  media: string | undefined;
}

export interface CrossBrandTrafficProps {
  brands: Brand[];
  crossBrandTrafficColors: {
    bgColor: string;
    selectedColor: string;
  };
}

export const useCrossBrandTraffic = ({ brands, siteLocale }: UseCrossBrandTrafficProps) => {
  const filterBrandsByLocale = (brands: Brand[]): Brand[] => {
    const localeSuffix = siteLocale === 'en_AU@AUD' ? 'AU' : 'NZ';
    const showProperty = `show${localeSuffix}` as 'showAU' | 'showNZ';

    return brands?.filter((brand) => brand[showProperty]);
  };

  const mapBrandData = (brand: Brand): ProcessedBrand => ({
    uniqueId: brand.uniqueId ?? '',
    url: brand.url ?? '',
    name: brand.name ?? '',
    media: brand.icon?.media?.file,
  });

  const processedBrands = brands ? filterBrandsByLocale(brands).map(mapBrandData) : [];

  return {
    processedBrands,
  };
};